import axios from 'axios'

const baseURL: unknown = import.meta.env.VITE_API_URL
const apiToken = import.meta.env.VITE_API_TOKEN as string | undefined

if (typeof baseURL !== 'string' || baseURL.length === 0) {
  throw new Error('VITE_API_URL env var must be a non-empty string')
}

export const axiosClient = axios.create({
  baseURL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    ...(apiToken ? { Authorization: `Bearer ${apiToken}` } : {}),
  },
})
